import src from "IMAGE";
export default { src, width: 269, height: 269, blurWidth: 0, blurHeight: 0};
